import React from "react";

/**
 * Function to determine the class and style based on the miles value and render the miles component.
 *
 * @param {object} miles - The miles object containing the value of miles
 * @return {JSX.Element} - The rendered miles component
 */
export const Miles = ({ miles }) => {
  /**
   * A function to determine the class based on the input miles.
   *
   * @param {number} miles - The input miles to determine the class.
   * @return {object} An object containing color, bg, and cls properties.
   */
  const getMilesClass = (miles) => {
    let color = "";
    let bg = "";
    if (miles >= 0 && miles <= 3) {
      color = "text-miles_one_color";
      bg = "bg-miles_one_bg";
    } else if (miles >= 4 && miles <= 8) {
      color = "text-miles_two_color";
      bg = "bg-miles_two_bg";
    } else if (miles >= 9 && miles <= 12) {
      color = "text-miles_three_color";
      bg = "bg-miles_three_bg";
    } else if (miles >= 13 && miles <= 18) {
      color = "text-miles_four_color";
      bg = "bg-miles_four_bg";
    } else if (miles >= 19 && miles <= 23) {
      color = "text-miles_five_color";
      bg = "bg-miles_five_bg";
    } else if (miles >= 24 && miles <= 30) {
      color = "text-miles_six_color";
      bg = "bg-miles_six_bg";
    } else {
      color = "text-miles_seven_color";
      bg = "bg-miles_seven_bg";
    }
    let cls = `${color} ${bg}`;
    return { color, bg, cls };
  };
  if (miles == null || miles == "-")
    return <div className="w-full text-center">-</div>;
  return (
    <span
      className={`line-clamp-1 w-[80px] !max-w-full break-all rounded-[4px] px-2 text-center text-[12px] font-medium leading-[20px] ${
        getMilesClass(miles).cls
      }`}
    >
      {miles} Miles
    </span>
  );
};
